import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import { TOOL_NAMES } from 'js/src/agent/toolNames';
import type { Skill } from '../types';

export const applyBrandKitSkill: Skill = {
    name: SKILL_NAMES.applyBrandKit,
    description:
        'Load BEFORE acting on any branding request — applying a saved kit, or using the colors the user calls their brand.',
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `# Applying Brand Kits

**Colors come from a brand kit or the template — never hand-picked.** With no kit,
the template's built-in colors and styling stand as-is: no \`${TOOL_NAMES.setBackground}\`/
\`${TOOL_NAMES.setText}\` color overrides, no \`${TOOL_NAMES.setGlobalColorGrading}\` to "fix" contrast, unless
the user specifically asks for a change.

## Applying an existing kit
Check \`${TOOL_NAMES.listBrandKits}\`. If a kit exists — or the user references their brand —
apply it with \`${TOOL_NAMES.applyBrandKit}\` (early, so everything built afterwards inherits it).

## When no kit exists
If the user wants one built from their website or brand, load the
\`${SKILL_NAMES.createBrandKit}\` skill and follow it. Otherwise say the workspace has no
brand kit saved, then continue with the template's own colors. Never approximate a
brand by hand-picking colors from their website or logo.

## Template pairing
A brand kit is a hard requirement to check during template choice: verify the
template works with the kit before committing to it, not after the video is built.`;
    },
};
